import React from 'react';
export function CheckIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87 10.8L5 12.72 10.13 18 19 7.8 17.02 6l-7 8.04-3.15-3.24z"
  }));
}